import { render, staticRenderFns } from "./deductionMumDialog.vue?vue&type=template&id=b42fe2b6&scoped=true&"
import script from "./deductionMumDialog.vue?vue&type=script&lang=js&"
export * from "./deductionMumDialog.vue?vue&type=script&lang=js&"
import style0 from "./deductionMumDialog.vue?vue&type=style&index=0&id=b42fe2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42fe2b6",
  null
  
)

export default component.exports